import { useMemo, useEffect, useState } from 'react';
export const useFocusedCategory = ({
  allCategories,
  visibleCategories
}) => {
  const [focusedCategory, setFocusedCategory] = useState(null);
  const sortByDisplayedOrder = useMemo(() => {
    const sortOrder = [...allCategories];
    return (a, b) => {
      const aIndex = sortOrder.indexOf(a);
      const bIndex = sortOrder.indexOf(b);
      return aIndex - bIndex;
    };
  }, [allCategories]);
  useEffect(() => {
    setFocusedCategory(visibleCategories.sort(sortByDisplayedOrder)[0]);
  }, [visibleCategories, sortByDisplayedOrder]);
  return focusedCategory;
};